import { useQuery } from "@tanstack/react-query";
import { getCategoryById } from "../../api/apiCategories";
import i18next from "i18next";

/**
 * Hook لجلب بيانات فئة مفردة بالـ ID
 * @param {number|string} id - Category ID
 */
export function useGetCategoryById(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["category", id, i18next.language],
        queryFn: () => getCategoryById(id),
        enabled: !!id,
        retry: false,
    });

    const category = data?.data || null;

    return { isLoading, error, category, refetch };
}
